(() => {
  const readReserved = (key) => {
    try {
      const value = Number(window.localStorage.getItem(key));
      return Number.isFinite(value) ? value : 0;
    } catch {
      return 0;
    }
  };

  const storeReserved = (key, reserved) => {
    try {
      window.localStorage.setItem(key, String(Math.max(readReserved(key), reserved)));
    } catch {}
  };

  document.querySelectorAll('[data-lvl-batch]').forEach((widget) => {
    const reservedValue = Number(widget.dataset.reserved);
    const maximumValue = Number(widget.dataset.reservedMax);
    const startingReserved = Math.min(100, Math.max(0, Number.isFinite(reservedValue) ? reservedValue : 92));
    const maximumReserved = Math.min(100, Math.max(startingReserved, Number.isFinite(maximumValue) ? maximumValue : 98));
    const progress = widget.querySelector('[role="progressbar"]');
    const date = progress?.querySelector('time')?.dateTime;
    if (!date) return;

    const storageKey = `livana.batch.reserved.${date}`;
    let reserved = Math.min(maximumReserved, Math.max(startingReserved, readReserved(storageKey)));
    const status = widget.querySelector('[data-lvl-batch-status]');
    const template = widget.dataset.reservedTemplate || '__PERCENT__% reserved';
    let timer;

    const render = () => {
      const reservationText = template.replaceAll('__PERCENT__', String(reserved));
      if (status) status.textContent = reservationText;
      if (progress instanceof HTMLElement) {
        progress.style.setProperty('--lvl-batch-fill', `${reserved}%`);
        progress.setAttribute('aria-valuenow', String(reserved));
        progress.setAttribute('aria-valuetext', reservationText);
      }
    };

    const schedule = () => {
      window.clearTimeout(timer);
      if (document.hidden || reserved >= maximumReserved) return;

      timer = window.setTimeout(() => {
        if (document.hidden) return;
        reserved += 1;
        storeReserved(storageKey, reserved);
        render();
        schedule();
      }, 5000 + Math.random() * 6000);
    };

    render();
    schedule();
    document.addEventListener('visibilitychange', schedule);
  });
})();
